import { t } from "../../../../i18n";
import PropTypes from 'prop-types';
import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AnimateButton from '../../../../component/extended/AnimateButton';
import { useEmailOtpSignIn } from 'hooks/useAuth';
function AuthEmailOtp({
  onUsePassword,
  ...others
}) {
  const theme = useTheme();
  const {
    formik,
    step,
    message,
    resendCode,
    changeEmail
  } = useEmailOtpSignIn();
  const isCodeStep = step === 'code';
  return <form noValidate onSubmit={formik.handleSubmit} {...others}>
            {isCodeStep ? <>
                    <Typography variant="subtitle1" fontWeight={600} textAlign="center" color="text.primary">{t("Código de acesso")}</Typography>
                    <Typography sx={{
        mt: 1
      }} textAlign="center" color="text.secondary">{t("Foi enviado um código para ")}<strong>{formik.values.email}</strong>.
                    </Typography>
                    <Box sx={{
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: 'repeat(8, minmax(0, 1fr))',
        gap: {
          xs: 0.75,
          sm: 1
        },
        width: '100%',
        maxWidth: 520,
        mx: 'auto',
        mt: 2
      }}>
                        <Box component="input" id="email-otp-code" name="code" type="text" value={formik.values.code} onBlur={formik.handleBlur} onChange={event => formik.setFieldValue('code', event.target.value.replace(/\D/g, '').slice(0, 8))} aria-label={t("Código de acesso com 8 dígitos")} autoComplete="one-time-code" autoFocus inputMode="numeric" pattern="[0-9]*" maxLength={8} sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          width: '100%',
          height: '100%',
          p: 0,
          border: 0,
          outline: 0,
          opacity: 0,
          cursor: 'text'
        }} />
                        {Array.from({
          length: 8
        }, (_, index) => <Box key={index} className="otp-digit" aria-hidden="true" sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 0,
          height: {
            xs: 52,
            sm: 64
          },
          border: '1px solid',
          borderColor: formik.values.code.length === index ? 'accent.main' : 'divider',
          borderRadius: 2,
          bgcolor: 'background.paper',
          color: 'text.primary',
          fontSize: {
            xs: '1.25rem',
            sm: '1.5rem'
          },
          fontWeight: 600,
          transition: theme.transitions.create(['border-color', 'box-shadow']),
          ...(formik.values.code.length === index && {
            boxShadow: `0 0 0 1px ${theme.palette.accent.main}`
          })
        }}>
                                {formik.values.code[index] || ''}
                            </Box>)}
                    </Box>
                    <Typography variant="body2" textAlign="center" color="text.secondary" sx={{
        mt: 1.5
      }}>{t("Cole ou escreva os 8 dígitos do código.")}</Typography>
                    {(formik.touched.code || formik.submitCount > 0) && t(formik.errors.code) && <FormHelperText error sx={{
        mt: 1,
        textAlign: 'center'
      }}>
                                {t(formik.errors.code)}
                            </FormHelperText>}
                </> : <FormControl fullWidth error={Boolean((formik.touched.email || formik.submitCount > 0) && formik.errors.email)} sx={{
      ...theme.typography.customInput
    }}>
                    <InputLabel htmlFor="email-otp-address">{t("Email")}</InputLabel>
                    <OutlinedInput id="email-otp-address" type="email" name="email" value={formik.values.email} onBlur={formik.handleBlur} onChange={formik.handleChange} label={t("Email")} autoComplete="email" autoFocus />
                    {(formik.touched.email || formik.submitCount > 0) && t(formik.errors.email) && <FormHelperText error>{t(formik.errors.email)}</FormHelperText>}
                </FormControl>}

            {t(message) && <Typography sx={{
      mt: 2
    }} color="success.main" variant="body2">
                    {t(message)}
                </Typography>}
            {t(formik.errors.submit) && <Box sx={{
      mt: 2
    }}>
                    <FormHelperText error>{t(formik.errors.submit)}</FormHelperText>
                </Box>}

            <Box sx={{
      mt: 2
    }}>
                <AnimateButton>
                    <Button disableElevation disabled={formik.isSubmitting || isCodeStep && formik.values.code.length !== 8} fullWidth size="large" type="submit" variant="contained" color="secondary">
                        {isCodeStep ? t('Entrar com código') : t('Enviar código')}
                    </Button>
                </AnimateButton>
            </Box>

            <Stack direction="row" justifyContent="center" flexWrap="wrap" sx={{
      mt: 1
    }}>
                {isCodeStep && <>
                        <Button type="button" variant="text" disabled={formik.isSubmitting} onClick={resendCode}>{t("Reenviar código")}</Button>
                        <Button type="button" variant="text" disabled={formik.isSubmitting} onClick={changeEmail}>{t("Alterar email")}</Button>
                    </>}
                <Button type="button" variant="text" disabled={formik.isSubmitting} onClick={onUsePassword} sx={{
        '&:not(.Mui-disabled)': {
          color: 'accent.main'
        }
      }}>{t("Entrar com password")}</Button>
            </Stack>
        </form>;
}
AuthEmailOtp.propTypes = {
  onUsePassword: PropTypes.func.isRequired
};
export default AuthEmailOtp;
